import React from 'react';

import IntermediatePage from '../components/IntermediatePage';
import TermosDeUso from 'pages/profile/components/regrasConvivencia/Termos';

const Termos = () => {
    return (
        <IntermediatePage
            helmetTitle="Termos de Uso"
            helmetMetaDescription="Termos de Uso da Plataforma humane do Instituto Ayrton Senna."
            title1=""
            title2="Termos e Condições"
            highlightedBanner
        >
            <TermosDeUso isLight />
        </IntermediatePage>
    );
};

export default Termos;
